import { render, staticRenderFns } from "./NotificationMenu.vue?vue&type=template&id=2e69a5f6&"
import script from "./NotificationMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports